import { useCallback, useRef } from "react";

export const useChatStreaming = (setMessages, scrollToBottom, isNearBottom) => {
  const streamingMessageIdRef = useRef(null);

  const handleStreamChunk = useCallback(
    (chunk) => {
      if (chunk.role === "model") {
        setMessages((prevMessages) => {
          const currentStreamingId = streamingMessageIdRef.current;

          const streamingMessageIndex = prevMessages.findIndex(
            (msg) => msg.id === currentStreamingId && msg.role === "model"
          );

          if (streamingMessageIndex !== -1) {
            const updatedMessages = [...prevMessages];
          updatedMessages[streamingMessageIndex] = {
            ...updatedMessages[streamingMessageIndex],
            content: chunk.content,
            follow_up: chunk.follow_up || null,
            steps: chunk.steps || updatedMessages[streamingMessageIndex].steps || null,
          };
            return updatedMessages;
          } else {
            const newId = `bot-${Date.now()}`;
            streamingMessageIdRef.current = newId;
            return [
              ...prevMessages,
            {
              id: newId,
              role: "model",
              content: chunk.content,
              follow_up: chunk.follow_up || null,
              steps: chunk.steps || null,
            },
            ];
          }
        });

        setTimeout(() => {
          if (isNearBottom()) {
            scrollToBottom();
          }
        }, 50);
      }
    },
    [setMessages, scrollToBottom, isNearBottom]
  );

  const resetStreaming = useCallback(() => {
    streamingMessageIdRef.current = null;
  }, []);

  return {
    handleStreamChunk,
    resetStreaming,
    streamingMessageIdRef,
  };
};
